// libraries.
import { useDispatch } from 'react-redux';
import { Eye, EyeOff } from 'lucide-react';

// slice.
import { togglePolygonVisibilityById } from '@domains/save-polygons/store/slices/modePolygon.slice';

interface Props {
  polygonId: string;
  hidden?: boolean;
}

export const ButtonTogglePolygonVisibility = ({
  polygonId,
  hidden,
}: Props) => {
  const dispatch = useDispatch();

  const handleToggle = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    dispatch(togglePolygonVisibilityById(polygonId));
  };

  const Icon = hidden ? EyeOff : Eye;
  const label = hidden ? 'Mostrar polígono' : 'Ocultar polígono';

  return (
    <button
      type="button"
      onClick={handleToggle}
      aria-label={label}
      title={label}
      className="btn btn-link p-0 border-0"
      style={{ color: hidden ? '#adb5bd' : '#0d6efd' }}
    >
      <Icon size={18} />
    </button>
  );
};
